import { render, staticRenderFns } from "./reportedList.vue?vue&type=template&id=52b9d06e&scoped=true&"
import script from "./reportedList.vue?vue&type=script&lang=js&"
export * from "./reportedList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52b9d06e",
  null
  
)

export default component.exports